import { BASE_URL_INTEGRATION } from './apiIntegrations';

const URL = `${BASE_URL_INTEGRATION}/`;

const AIRTABLE_SERVICES = [
  {
    text: '------',
    value: '',
    method: '',
    url: '',
    params: [],
    body: '',
    headers: [],
    response: '',
  },
  {
    text: 'Save new row',
    value: 'create',
    method: 'post',
    url: `${URL}airtable/create_records`,
    params: [],
    body: `{
          "apiKey": "",
          "baseId": "",
          "baseName": "",
          "records": [
              {
                  "fields": {
                  "name": "",
                  "desc": "",
                  "image": [
                      {
                      "url": ""
                      }
                  ],
                  "price": 0.0
                  }
              },
              {
             
                  "fields": {
                  "image": [
                      {
                          "url": ""
                          }
                  ],
                  "price": 5000,
                  "name": "",
                  "desc": "",
              "Image2": ""
                 
              }
              }
          ],
          "addDate": true,
          "addDateLabel": "date"
      }
      `,
    headers: [{
      name: 'content-type',
      value: 'application/json',
    },
    ],
    response: `
      {"type": "array"}
    `,
  },
  {
    text: 'Get data',
    value: 'read',
    method: 'post',
    url: `${URL}airtable/get_records`,
    params: [],
    body: `{
          "apiKey": "",
          "baseId": "",
          "baseName": "",
          "options": {
              "filterByFormula": "OR({Title} = 'The Stone Sky', {Genre} = 'Fantasy' )",
              "fields": ["Title", "Genre", "Author"],
              "maxRecords": 1,
              "sort": [{"field": "Published On", "direction": "asc"}]
          }
      }`,
    headers: [],
    response: `{"type": "object",
        "properties": {
            "id": {
                "type": "string"
             },
             "createdTime": {
                "type": "date"
             },
             "fields": {
                "type": "object",
             "properties": {
               
             }
             }
        }
    }
    `,
  },
  {
    text: 'Update row',
    value: 'update',
    method: 'patch',
    url: `${URL}airtable/update_records`,
    params: [],
    body: `{
          "apiKey": "",
          "baseId": "",
          "baseName": "",
          "fields": {"price": 0.0, "name": ""},
          "id": "",
          "addDate": true, 
          "addDateLabel": "date"
      }`,
    headers: [{
      name: 'content-type',
      value: 'application/json',
    },
    ],
    response: '{}',
  },
  {
    text: 'Delete row',
    value: 'delete',
    method: 'delete',
    url: `${URL}airtable/delete_records`,
    params: [],
    body: `{
          "apiKey": "",
          "baseId": "",
          "baseName": "",
          "id": []
    }`,
    headers: [{
      name: 'content-type',
      value: 'application/json',
    },
    ],
    response: `
    {"type": "object",
        "properties": {
            "msg": {
                "type": "string"
             }
        }
    }
    `,
  },
];

export default AIRTABLE_SERVICES;
